import React from "react";
import { Card, CardContent } from "../../../tailwind/card";

export const EmptyInvoiceState = () => (
  <Card className="border-dashed">
    <CardContent className="flex flex-col items-center justify-center py-12">
      <div className="text-gray-400 dark:text-gray-600 mb-4">
        <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">No Invoices Found</h3>
      <p className="text-gray-600 dark:text-gray-400 text-center max-w-sm">
        You don't have any invoices yet. Your invoices will appear here once your subscription becomes active.
      </p>
    </CardContent>
  </Card>
);
